export enum AlertTypes {
  danger = 'danger',
  info = 'info',
  success = 'success',
  warning = 'warning',
  details = 'details',
}

export type AlertType = keyof typeof AlertTypes;
